import React, { useEffect, useState } from 'react';
import FolderTree from '../Componentes/Documentacion/FolderTree';
import EditFolderPermission from '../Componentes/Documentacion/EditFolderPermission';
import { useNavigate, useParams } from 'react-router-dom';
import { collection, getDocs, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import GetUserData from '../Hooks/GetUserData';

const VisualizadorDoc = () => {
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [selectedFolderName, setSelectedFolderName] = useState('');
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [accessLogs, setAccessLogs] = useState(null);
  const navigate = useNavigate();
  const { hubId } = useParams();
  const [refreshFolders, setRefreshFolders] = useState(false);
  const { userData } = GetUserData();

  const triggerFolderRefresh = () => setRefreshFolders(prev => !prev);

  // Escuchar documentos de la carpeta seleccionada y llamar a la función
  useEffect(() => {
    if (!selectedFolderId) return;

    const q = query(
      collection(db, 'private-hubs', hubId, 'Documentos'),
      where('folderId', '==', selectedFolderId)
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const docs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setDocuments(docs);
      console.log('Documentos actualizados:', docs);

      // Llamar a la Cloud Function blocktraceGetDocumentsAccessLogs
      const result = await fetchBlocktraceAccessLogs(docs, userData);
      if (result?.success) {
        setAccessLogs(result);
      } else {
        setAccessLogs(null);
      }
    });

    return () => unsubscribe();
  }, [selectedFolderId, hubId, userData]);

  async function fetchBlocktraceAccessLogs(docs, userData) {
    try {
      const response = await fetch(
        'https://us-central1-lyseis-tools-hub.cloudfunctions.net/blocktraceGetDocumentsAccessLogs',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            documentos: docs,
            requestedBy: userData?.email,
            filters: { limit: 50, action: 'DOWNLOAD' },
          }),
        }
      );

      if (response.status === 204) return null;
      if (!response.ok) {
        const text = await response.text();
        console.error(`Error HTTP ${response.status}:`, text);
        return null;
      }

      const result = await response.json();
      console.log('Logs de acceso obtenidos:', result);
      return result;

    } catch (error) {
      console.error('Error de red o fetch fallido:', error);
      return null;
    }
  }


  // Función auxiliar para transformar los logs y mostrar el nombre del documento
  const flattenLogs = (data, docs) => {
    if (!data?.results) return [];

    return data.results.flatMap(docResult => {
      return (docResult.logs || []).map(log => {
        const originalDoc = docs.find(
          d => d.blocktraceInfo?.documentId === docResult.blocktraceId
        );

        return {
          documento: originalDoc ? originalDoc.name : docResult.localId,
          tipo: log.action,
          usuario: log.userId,
          timestamp: log.timestamp,
        };
      });
    });
  };

  const allLogs = flattenLogs(accessLogs, documents);

  return (
    <div className="lobby-container" style={{alignItems: 'normal'}}>
      {/* Header */}
      <div className="header-container">
        <header className="header">
          <h1 className="header-title">Visualizador de Registros</h1>
          <div className="logout-button-container">
            <button onClick={() => navigate(-1)} className="logout-button">
              ← Volver
            </button>
          </div>
        </header>
      </div>

      {/* Contenido principal */}
      <div>
        <div className="dashboard-column">
          {/* Tabla de logs */}
          <div className="data-box mt-4">
            <h2 className="data-box-title">Registros de acceso de {selectedFolderName}</h2>
            {!selectedFolder ? (<p>Seleccione una carpeta para ver los registros.</p>) : null}
            {allLogs.length === 0 ? (
              <p>No hay registros disponibles.</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="data-table min-w-full border border-gray-300 text-sm text-left">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-4 py-2">Documento</th>
                      <th className="border px-4 py-2">Tipo de Log</th>
                      <th className="border px-4 py-2">Usuario</th>
                      <th className="border px-4 py-2">Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs.map((log, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="border px-4 py-2">{log.documento}</td>
                        <td className="border px-4 py-2">{log.tipo}</td>
                        <td className="border px-4 py-2">{log.usuario}</td>
                        <td className="border px-4 py-2">
                          {new Date(log.timestamp).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        {/* Columna izquierda */}
        <div className="dashboard-column">
          <div className="data-box">
            <h2 className="data-box-title">Carpetas</h2>
            <FolderTree
              onSelectFolder={(folderName, folderId) => {
                setSelectedFolderName(folderName);
                setSelectedFolderId(folderId);
              }}
              onSelectFolderObject={(folderObj) => setSelectedFolder(folderObj)}
              refresh={refreshFolders}
            />
          </div>
        </div>


      </div>
    </div>
  );
};

export default VisualizadorDoc;
